/**
 * @description Hook utilizado para manipular as informações
 * @author Diego Sabino Amorim de Araújo
 * @file useInformacaoService.js
 * @license Copyright (c) 2024 SIGEP DIGETI ITEP/RN
 */

import { useFetch } from './useFetch'

export const useInformacaoService = () => {
  const fetch = useFetch()

  const cadastrarInformacao = async (dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)

      await fetch.postOpen(`/informacao/`, dados)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarInformacoesDeEntidade = async (id, tipo, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      let result = null
      switch (tipo) {
        case 'caso': {
          const response = await fetch.get(`/informacao/caso/${id}`)
          result = response.data.informacoes
          break
        }
        case 'vestigio': {
          const response = await fetch.get(`/informacao/vestigio/${id}`)
          result = response.data.informacoes
          break
        }
        case 'periciando': {
          const response = await fetch.get(`/informacao/periciando/${id}`)
          result = response.data.informacoes
          break
        }
        case 'veiculo': {
          const response = await fetch.get(`/informacao/veiculo/${id}`)
          result = response.data.informacoes
          break
        }
        case 'cadaver': {
          const response = await fetch.get(`/informacao/cadaver/${id}`)
          result = response.data.informacoes
          break
        }
        case 'local': {
          const response = await fetch.get(`/informacao/local/${id}`)
          result = response.data.informacoes
          break
        }
        case 'exameSolicitado': {
          const response = await fetch.get(`/informacao/exameSolicitado/${id}`)
          result = response.data.informacoes
          break
        }
        case 'solicitacaoExame': {
          const response = await fetch.get(`/informacao/solicitacaoExame/${id}`)
          result = response.data.informacoes
          break
        }
        default: {
          break
        }
      }
      return result
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }
  return { cadastrarInformacao, listarInformacoesDeEntidade }
}
